import React from 'react'

function NotFoundPage() {
    return (
      <div>
        <h1>404 - Δεν έχετε πρόσβαση σε αυτή την σελίδα.</h1>
      </div>
    );
  }
  
  export default NotFoundPage;
  
